<template>
    <component :is="'VuePerfectScrollbar'" ref="filterScroll" class="filters_scroll_area"  :settings="settings" :key="$vs.rtl">
        <div class="todo__filters-container">
            <div>
                <div class="px-6 py-4">
                    <!-- Кнопка сбросить фильтр -->
                    <div class="flex cursor-pointer" @click="filterRouteAll()">
                        <feather-icon icon="FilterIcon" svgClasses="h-6 w-6"></feather-icon>
                        <span class="text-lg ml-3">{{$t('show_all')}}</span>
                    </div>
                </div>

                <vs-divider class="mb-0 mt-0"></vs-divider>

                <!-- Фильтры -->
                <div class="px-6 py-4 border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid" v-for="(filter, name, index) in filterActive" :key="`f_${index}`">
                    <h5 :class="['mb-3 select_label', requiredSelectLabel(name)]">
                        {{ filterLabelReplace(name) }}
                    </h5>

                    <multiselect
                        v-model="filterActive[name]"
                        :options="dynamicOptions(name)"
                        :selectedLabel="$t('selected')"
                        :placeholder="filterLabelReplace(name)"
                        @open="openSelect(name)"
                        @close="selectClose"
                        :loading="isLoading[name]"
                        :custom-label="multiselectLabel"
                        @select="multiselectAction($event, name)"
                        @remove="multiselectRemove($event, name)"
                        deselectLabel=""
                        selectLabel=""
                        :disabled="name === 'acad_period' && disable_acad_period"
                        :track-by="name === 'student' ? 'profileId' : 'uid'">
                            <template slot="singleLabel" slot-scope="props">
                                {{ titleTemplate(name, props) }}
                            </template>
                            <template slot="option" slot-scope="props">
                                {{ titleTemplate(name, props) }}
                            </template>
                            <div slot="noOptions">
                                {{$t('no_data_text')}}
                            </div>
                    </multiselect>
                </div>

                <div class="px-6 py-4 lg:hidden">
                    <vs-button @click="sidebarToggle()" class="w-full">{{$t('apply')}}</vs-button>
                </div>
            </div>
        </div>
    </component>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapState } from "vuex";
export default {
    props: {
        itemHandler: {
            type: Function,
            default: () => {}
        },
        requiredFilter: {
            type: Array
        },
        sidebarToggle: {
            type: Function,
            required: true
        }
    },

    data() {
        return {
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.60
            },
            loading: false,
            isLoading: {
                acad_period: false,
                study_year: false,
                study_plan: false,
            },
            filterActive: {
                study_year: null,
                study_plan: null,
                acad_period: null
            },
            study_year_chosen: false,
            study_plan_chosen: false
        }
    },

    watch: {
        'filterActive.study_year'(){
            this.filterActive.acad_period = null;
            this.$store.commit('perfomance/CLEAR_ACADEM_PERIOD');
            this.setActiveFilters()
        }
    },
    created: function() {
        // Запрашиваем активные фильтры
        this.setActiveFilters()
    },
    computed: {
        ...mapState({
            acad_period: state => state.perfomance.acad_period,
            study_year: state => state.perfomance.study_year,
            study_plan: state => state.perfomance.study_plan,
        }),
        scrollbarTag () { return this.$store.getters.scrollbarTag },
        disable_acad_period(){
            if( this.study_year_chosen === false || this.study_plan_chosen === false){
                return true
            }else{
                return false
            }
        }
    },
    // watch: {
    //     'filterActive.study_year'(){
    //         this.filterActive.acad_period = null;
    //         this.setActiveFilters();
    //         this.$store.commit('perfomance/CLEAR_ACADEM_PERIOD');
    //     }
    // },
    methods: {
        filterLabelReplace(name) {
            if(name === 'acad_period') return this.$t('acad_periods')
            else return this.$t(name)
        },
        requiredSelectLabel(name) {
            // Помечаем обязательные фильтры
            if(this.requiredFilter.find(key => key === name)) return 'required'
        },
        filterRouteAll() {
            // При нажатии на кнопку показать все, убираем все фильтры и обновляем список
            if(Object.keys(this.$route.query).length) {
                this.$store.commit('perfomance/CLEAR_STUDENT_LIST')

                this.$router.push({name: 'my-performance'})
                for (let query in this.filterActive) {
                    this.filterActive[query] = ''
                }
                this.updateHandler()
            }
            // Нужно, чтобы делать фильтр acad_period неактивным для выбора
            this.study_year_chosen = false
            this.study_plan_chosen = false
        },
        titleTemplate(key, props) {
            // Возвращаем для нужного ключа шаблог для поля multiselect
            if(key === 'study_year') return `${ props.option.start } - ${ props.option.end }`
            if(key === 'study_plan') return  props.option.education_program.name
            else return props.option.name
        },
        dynamicOptions(name) {
            // Так как поле настроек видимости выводиться в цикле, через эту функцию подставляем нужные данные в поле
            return this[name]
        },
        multiselectLabel(item) {
            // Заменяем лэйбл для поиска в селекте
            if(item.start) return `${ item.start } - ${ item.end }`
            else return item.name
        },
        filterParamsRefresh(key, query) {
            // Подставляем сгенерированный query в строку браузера
            this.$router.push({query})
        },
        multiselectAction (item, key) {
            // Функция выбора фильтра
            let query = Object.assign({}, this.$route.query)
            query[key] = item.uid

            // Делаем запрос на очищение фильтров о подмены query в строке браузера
            this.filterParamsRefresh(key, query)

            // Обновляем данные на станице
            this.updateHandler()

            // Нужно, чтобы делать фильтр acad_period активным для выбора
            let key_chosen = key +'_chosen'
            this[key_chosen] = true
        },
        multiselectRemove (item, key) {
            // Функция отменяет выбранный фильтр
            let query = Object.assign({}, this.$route.query)
            delete query[key]
            delete query['acad_period']
            // Делаем запрос на очищение фильтров о подмены query в строке браузера
            this.filterParamsRefresh(key, query)

            // Обновляем данные на станице
            this.updateHandler()

            // Нужно, чтобы делать фильтр acad_period неактивным для выбора
            let key_chosen = key +'_chosen'
            this[key_chosen] = false
            this.filterActive.acad_period = null
        },
        updateHandler() {
            this.$store.commit('perfomance/CLEAR_STUDENT_LIST')

            this.itemHandler({update:true})
        },
        selectClose() {
            // Инициализируем скролл
            this.$refs['filterScroll'].__init()
        },
        async openSelect(type) {
            // Останавливаем скролл
            this.$refs['filterScroll'].__uninit()

            // События открытия выпадающего списка, при открытии либо запрашиваем данные для поля с сервера, либо получаем со стора ранее запрошенные данные
            try {
                // Включаем у селекта индикатор загрузки
                this.isLoading[type] = true
                await this.$store.dispatch('perfomance/checkSelectType', {type, query: this.$route.query})
            } catch(e) {
                this.$vs.notify({
                    text: this.$t(e.message),
                    color: 'danger',
                })
            } finally {
                // Отключаем у селекта индикатор загрузки
                this.isLoading[type] = false
            }
        },
        async setActiveFilters() {
            // Если query не пустой, в цикле запрашиваем с сервера нужные активные фильтры, и делаем их визуально выбранными
            if(Object.keys(this.$route.query).length) {
                for (let key in this.$route.query) {
                    try {
                        this.isLoading[key] = true
                        const res = await this.$store.dispatch('perfomance/checkSelectType', {type: key, query: this.$route.query})
                        this.filterActive[key] = res.find(item => item.uid === this.$route.query[key])
                    } catch(e) {
                        this.$vs.notify({
                            text: this.$t('error'),
                            color: 'danger',
                        })
                    } finally {
                        this.isLoading[key] = false
                    }
                }
            }
        }
    },
    components: {
        VuePerfectScrollbar
    }
}
</script>

<style scoped lang="scss">
.select_label{
    &.required{
        &::after{
            content: "*";
            color: rgba(var(--vs-danger),1);
            display: inline-block;
            margin-left: 3px;
        }
    }
}
</style>

<style lang="scss">
.todo__filters-container{
    .multiselect__single{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}
</style>
